/** Costanti della run condivise tra run.ts e talismans.ts (niente cicli di import). */
export const TOTAL_ROUNDS = 12;
export const HANDS_PER_ROUND = 3;
export const TILT_PER_FORCE = 35;
export const TILT_MAX = 100;
export const SHOP_REROLL_COST = 2;

// Curva obiettivi: parametri tarati con scripts/simulate.ts (win-rate target 15-25%).
export const TARGET_BASE = 35;
export const TARGET_GROWTH = 1.32;
